import React, { memo } from "react";
import { useLocation } from "react-router-dom";

import { SwiperSlide } from "swiper/react/swiper-react";
import { SearchNormal1 } from "iconsax-react";

import useFilter from "../../../hooks/useFilter";

import SingleSimCardComponent from "../singleSimCard";
import ButtonComponent from "../button";
import { SlideNextButton, SlidePrevButton } from "../home/simsCarousel";

import { ResultCarousel, StyledSwiper, ResultCategories } from "./styledSearch";

const SearchResultCarouselComponent = ({
  runAxios,
  searchResult,
  setShowAllItems,
  filterCategories,
  setFilter,
}) => {
  const { onChange } = useFilter();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const queryParams = params.get("q");

  const categories = [
    {
      id: 1,
      name: "پایه تحصیلی",
      filter: filterCategories?.grade,
      filterType: "grade",
    },
    {
      id: 2,
      name: "موضوع آزمایش",
      filter: filterCategories?.subject,
      filterType: "subject",
    },
  ];

  const handleShowAllItems = () => {
    setShowAllItems(true);
    setFilter({
      isFilter: false,
      filterName: null,
      filterType: null,
    });
  };

  const FilterSearch = () => {
    const handleCategoryFilter = (type) => {
      const gradeFilter = filterCategories.grade;
      onChange("filter", type);
      setFilter({
        isFilter: true,
        filterName: gradeFilter ? categories[0].name : categories[1].name,
        filterType: gradeFilter
          ? categories[0].filterType
          : categories[1].filterType,
      });
      setShowAllItems(true);
      runAxios.filterCategoriesRun(undefined, {
        q: queryParams,
        type: type,
        page_size: 12,
        page: 1,
      });
    };

    return (
      <div className="filter-categories-box pt-4 mx-2">
        {categories.map((item) => (
          <React.Fragment key={item.id}>
            {item.filter && (
              <ResultCategories className="mb-3">
                <SearchNormal1 size="25" color="var(--dark-color)" />
                <section className="px-2">
                  <p className="mb-1">{queryParams}</p>
                  <span className="mb-1">در دسته&nbsp;</span>
                  <ButtonComponent
                    className="blue-detail d-inline px-0"
                    variant="link"
                    onClick={() => handleCategoryFilter(item.filterType)}
                  >
                    {item.name}
                  </ButtonComponent>
                </section>
              </ResultCategories>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };

  return (
    <ResultCarousel className="mt-1 py-4 px-2 px-md-4">
      <ResultCategories className="px-2 mb-3">
        <SearchNormal1 size="25" color="var(--dark-color)" />
        <span className="text m-0 mx-2">آزمایش‌های مرتبط با</span>
        <span className="blue-detail">{queryParams}</span>
      </ResultCategories>
      <StyledSwiper
        slidesPerView={1}
        breakpoints={{
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 2,
          },
          1440: {
            slidesPerView: 3,
          },
          1860: {
            slidesPerView: 4,
          },
        }}
        spaceBetween={6}
        loop={searchResult?.estimatedTotalHits > 2 ? true : false}
        className="py-3"
      >
        {searchResult?.hits.map((product, index) => {
          return (
            <SwiperSlide key={index}>
              <SingleSimCardComponent $Carousel data={product} className="my-2" />
            </SwiperSlide>
          );
        })}
        {searchResult?.estimatedTotalHits > 2 && (
          <>
            <SlidePrevButton
              color="var(--primary-color)"
              className="prev-button"
            />
            <SlideNextButton
              color="var(--primary-color)"
              className="next-button"
            />
          </>
        )}
      </StyledSwiper>
      {queryParams && (
        <ButtonComponent
          className="all-result-button d-block mx-auto my-3"
          onClick={handleShowAllItems}
        >
          مشاهده همه موارد
        </ButtonComponent>
      )}
      {(filterCategories?.subject || filterCategories?.grade) && (
        <FilterSearch />
      )}
    </ResultCarousel>
  );
};

export default memo(SearchResultCarouselComponent);
